import { render } from "./GiftListedNftModal.vue?vue&type=template&id=fe3bd8ec&scoped=true"
import script from "./GiftListedNftModal.vue?vue&type=script&lang=js"
export * from "./GiftListedNftModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/giftNftModal.scss?vue&type=style&index=0&id=fe3bd8ec&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe3bd8ec"]])

export default __exports__